import { Skeleton, Tooltip } from "@mui/material";
import classNames from "classnames";
import { useEffect, useState } from "react";
// import MultiAxisLineChart from "shared/components/lineGraph";
import MultiAxisLineChart from "shared/components/lineGraph";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import { getPartnersGraphData } from "shared/services/projectHeadService";
import moment from "moment";
import { user_roles } from "shared/utils/constants";
import { Icons } from "assets";

function AccountStatsGrid() {
  return (
    <div className={styles.accountsContainer}>
      <AccountCard isPublisher />
      <AccountCard isAuthor />
    </div>
  );
}

export default AccountStatsGrid;

const AccountCard = ({ isPublisher, isAuthor }: any) => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [graphData, setGraphData] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);

  const getStats = () => {
    setLoader(true);
    getPartnersGraphData(
      {
        from: moment(startDate).format("YYYY-MM-DD"),
        to: moment(endDate).format("YYYY-MM-DD"),
      },
      isAuthor ? user_roles.author : user_roles.publisher
    )
      .then(({ data: { data } }) => {
        setLoader(false);
        setGraphData(data);
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStats();
    }

    //eslint-disable-next-line
  }, [startDate, endDate]);

  let dataSetsForGraphs = [
    {
      label: "New Sign-Up",
      data: graphData?.new_signups,
      borderColor: "#9A469B",
      backgroundColor: "rgba(154, 70, 155, 0.175)",
      pointRadius: 5,
      pointHoverRadius: 7,
      fill: true,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#9A469B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "MOU Pending",
      data: graphData?.pending_mou,
      borderColor: "#EF437B",
      backgroundColor: "rgba(239, 67, 123, 0.175)",

      pointRadius: 5,
      pointHoverRadius: 7,
      fill: true,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFF",
    },
    {
      label: "Approved accounts",
      data: graphData?.accepted_mou,
      borderColor: "#1897A6",
      backgroundColor: "rgba(24, 151, 166, 0.175)",
      pointRadius: 5,
      pointHoverRadius: 7,
      fill: true,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFF",
    },
  ];

  const legends = [
    {
      label: "New Sign-up",
      info: "Newly added accounts",
      color: "#9A469B",
    },
    {
      label: "MOU Pending",
      info: "MOU Pending Accounts",
      color: "#EF437B",
    },
    {
      label: "Approved Accounts",
      info: "MOU Approved Accounts",
      color: "#1897A6",
    },
  ];
  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <label className={styles.heading}>
          {isPublisher
            ? "Publishers Accounts"
            : isAuthor
            ? "Authors Accounts"
            : ""}
        </label>
        <div>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>
      <div className={styles.legendContainer}>
        {legends?.map((item: any) => {
          return (
            <div className={styles.singleLegendContainer} key={item.label}>
              <Tooltip
                componentsProps={{
                  tooltip: { className: "tooltip" },
                  arrow: { className: "arrow" },
                }}
                placement="top"
                arrow
                title={item?.info}
              >
                <div className={styles.dot} style={{ background: item?.color }}>
                  i
                </div>
              </Tooltip>
              <label className={styles.legendLabel}>{item?.label}</label>
            </div>
          );
        })}
      </div>
      <div className={styles.graphContainer}>
        {loader ? (
          <Skeleton variant="rectangular" className={styles.graphLoader} />
        ) : (
          <MultiAxisLineChart
            datasets={dataSetsForGraphs}
            legend={false}
            labels={graphData?.labels}
          />
        )}
      </div>
      <div className={classNames(styles.grid, styles.btnContainer)}>
        <button
          className={styles.viewDetail}
          onClick={() => {
            if (isPublisher) {
              navigate(
                routeConstant.partnersDetail.path.replace(
                  ":keyword",
                  "publisher"
                )
              );
            } else if (isAuthor) {
              navigate(
                routeConstant.partnersDetail.path.replace(":keyword", "author")
              );
            }
          }}
        >
          View Detail <Icons.ArrowPointLeft />
        </button>
      </div>
    </div>
  );
};
